export default __webpack_public_path__ + "static/media/project_ico.44cb8108.svg";